import {formatInTimeZone} from "date-fns-tz";

export const formatDate = (
    dateString: string,
    format: string = 'd MMM yyyy HH:mm', // Формат по умолчанию
): string | null => {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
        console.error('Invalid date string');
        return null;
    }

    // Получаем часовой пояс пользователя
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Форматируем дату с учетом часового пояса, формата и локали
    return formatInTimeZone(date, userTimeZone, format);
}